import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

import { VAR_AREA_TOP } from '@mopla/constants';

export interface IOwnerState {
	rounded: boolean;
	withIcons: boolean;
}

export const Root = styled('div')<{ ownerState: IOwnerState }>(
	({ ownerState: { rounded, withIcons } }) => ({
		borderRadius: rounded ? '0 0 8px 8px' : 0,
		display: 'grid',
		gridTemplateColumns: withIcons
			? '[start] 40px [ts] 1fr [te] 40px [end]'
			: '[ts start] 1fr [te end]',
		gridTemplateRows: 'max-content',
		gap: 16,
		gridAutoRows: 'max-content',
		justifyContent: 'space-between',
		padding: '12px 16px',

		'.withSafeAreaTop &': {
			padding: `calc(${VAR_AREA_TOP} + 12px) 16px 12px`,
		},

		'@media(max-width: 900px)': {
			transition: 'height .2s',
		},
		alignItems: 'center',
	})
);

export const Title = styled(Typography)(() => ({
	color: 'inherit',
	justifySelf: 'center',
	textAlign: 'center',
	gridColumn: 'ts / te',
}));

export const ChildrenWrapper = styled('div')(() => ({
	gridColumn: 'start / end',
}));
